import React from 'react';
import {useStyle} from './helper'
import {useRouter} from '../../../../../@casino/useRouter';

const MailingUsersItem = (props) => {
    const classes = useStyle();

    return (
        <div 
            className={classes.root} 
        >
            <span className={classes.online}>{props?.gift_type}:{props?.gift_value}</span>
            <div className={classes.wrapLogin}>
                <span>{props?.login}</span>
            </div>
            {
                props?.mailing?.is_start && !props?.comments_from_operator ? (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <button
                            type="button"
                            className={classes.btn}
                            onClick={() => {
                                props.setIsOpenModalComments(value => !value);
                                props.setSelected(props)
                            }}
                        >
                            Оставить комментарий
                        </button>
                    </div>
                ) : props?.comments_from_operator?.length > 50 ? props?.comments_from_operator.slice(0, 50) + '...' : props?.comments_from_operator
            }
        </div>
    )
}

export default MailingUsersItem;